import { Card, Col, Form, Input, Row, Space, Typography } from "antd";
import React from "react";
const { Title } = Typography;


const Requester = ({ getChildData }) => {
  const callparent = (e, name) => {
    getChildData(e, name)
  }
  const validatePhone = (_, value) => {
    // Example regex for phone number validation (adjust as needed)
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Please enter a valid phone number.'));
  };
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          Requester Information
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-1 lg:px-6 mb-4">
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterFName")}
            name="rfirstname"
            label="First Name"
            rules={[
              { required: true, max: 50, message: "Please enter first name." },
            ]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterLName")}
            name="rlastname"
            label="Last Name"
            required
            rules={[{ required: true, max: 50, message: "Please enter last name." }]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterEmail")}
            name="requesteremail"
            label="Email"
            rules={[
              { required: true, max: 100, message: "Please enter email." },
              {
                type: "email",
                message: "Please enter valid email.",
              },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterPhoneNumber")}
            name="requesterphone"
            label="Phone Number"
            rules={[
              { required: true, max: 20, message: "Please enter phone number." },
              { validator: validatePhone },
            ]}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterAddLine1")}
            label="Address Line 1 "
            name="raddress1"

          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            layout="vertical" name="raddress2" label="Address Line 2" onChange={(e) => callparent(e.target.value, "RequesterAddLine2")}>
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterCity")}
            name="rcity"
            label="City"
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterState")}
            name="rstate"
            label="State"
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterZipCode")}
            name="rzipcode"
            label="Zip Code"
          >
            <Input maxLength={8} />
          </Form.Item>
        </Col>
      </Row>

      <Space direction="horizontal" className="px-1 md:px-6">
        <i className="text-base notes-ilatic">
          Please note: There <u>may be</u> a <u>fee</u> for processing your request. If
          there is a fee, we will reach out to the <u>requester</u> with the
          next steps for payment collection.
        </i>
      </Space>
    </Card>
  );
};


export default Requester;
